import { atom } from 'jotai';
import { User } from 'types/user';

export const user = atom<User | null>(null);
